import { useMemo, memo } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import EcoVideo from 'eco-design/base/eco-video';

import styles from './index.module.scss';
import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';

function SectionC() {
    const { t } = useLang('theProduct.SectionC');

    const tipArr = useMemo(
        () => [
            {
                title: t('info1_title'),
                desc: t('info1_desc'),
                value: t('info1_value'),
                img: {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1760944067457/sectionc_info_1.png',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1761709813294/sectionc_info_1_h5.png',
                },
            },
            {
                title: t('info2_title'),
                desc: t('info2_desc'),
                img: {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1760944067201/sectionc_info_2.png',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1761709813224/sectionc_info_2_h5.png',
                },
            },
        ],
        [t],
    );

    return (
        <div className={`${styles.SectionC} GtmModuleData-section`} data-section-id="on-the-road-SectionC">
            <EcoSpace />

            <div className="container-box">
                <div className="comp-bg">
                    <EcoVideo
                        pc="https://websiteoss.ecoflow.com/upload/video/1761617497905/sectionc_video.mp4"
                        poster="https://websiteoss.ecoflow.com/upload/image/1761646421800/sectionc_1.jpg"
                        autoPlay={true}
                        loop={true}
                    />
                </div>

                <div className="info-box">
                    <div className="info-container">
                        <div className="info-left">
                            <p className="info-left-label">{t('label')}</p>
                            <p className="info-left-title">{t('title')}</p>
                            <p className="info-left-sub-title">{t('sub_title')}</p>
                            <p className="info-left-desc">{t('desc')}</p>
                        </div>
                        <div className="info-right">
                            <p className="info-title">{t('info_title')}</p>
                            {tipArr.map((item, index) => (
                                <div className="info-item" key={index}>
                                    <div className="info-item-content">
                                        <div className="info-item-box">
                                            <div className="info-item-left-text">
                                                <p className="info-item-desc">{item.desc}</p>
                                                <p className="info-item-title">{item.title}</p>
                                            </div>

                                            {item?.value && <p className="info-item-value">{item.value}</p>}
                                        </div>
                                    </div>
                                    <EcoImg className="info-item-img" pc={item?.img?.pc} h5={item?.img?.h5} isOpenLazy />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default memo(SectionC);
